import { render, staticRenderFns } from "./ContainersReservations.vue?vue&type=template&id=70633d66&"
import script from "./ContainersReservations.vue?vue&type=script&lang=js&"
export * from "./ContainersReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports